import { render, staticRenderFns } from "./basePriceInfo.vue?vue&type=template&id=2eee3df4&scoped=true"
import script from "./basePriceInfo.vue?vue&type=script&lang=js"
export * from "./basePriceInfo.vue?vue&type=script&lang=js"
import style0 from "./basePriceInfo.vue?vue&type=style&index=0&id=2eee3df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee3df4",
  null
  
)

export default component.exports